import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  // 导航链接数据
  const navLinks = [
    { path: '/', label: '首页' },
    { path: '/ai-job-radar', label: 'AI校招雷达' },
    { path: '/services', label: 'AI服务', featured: true },
    { path: '/news', label: '资讯' },
    { path: '/about', label: '关于' },
    { path: '/contact', label: '咨询' }
  ];

  // 监听滚动事件，更新导航栏样式
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // 监听窗口大小变化，在大屏幕上自动关闭移动菜单
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 点击链接后关闭移动菜单
  const handleLinkClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header
      className={`nav ${scrolled ? 'nav--scrolled' : ''} ${mobileMenuOpen ? 'nav--mobile-open' : ''}`}
      role="navigation"
    >
      <div className="nav__inner">
        <Link to="/" className="nav__brand">
          <img src="/images/favicon.svg" alt="山间码坊 Logo" className="nav__logo" />
          <span>山间码坊</span>
        </Link>
        
        {/* 移动端汉堡菜单按钮 */}
        <button 
          className="nav__mobile-toggle" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label={mobileMenuOpen ? "关闭菜单" : "打开菜单"}
        >
          <span className="nav__mobile-icon"></span>
        </button>
        
        {/* 桌面端导航链接 */}
        <nav className="nav__links">
          {navLinks.map((link) => (
            <Link 
              key={link.path}
              className={[
                location.pathname === link.path ? 'active' : '',
                link.featured ? 'nav__link--featured' : ''
              ].filter(Boolean).join(' ')}
              to={link.path} 
              onClick={handleLinkClick}
            >
              <span>{link.label}</span>
              {link.featured && <span className="nav__link-badge">热门</span>}
            </Link>
          ))}
        </nav>
        
        {/* 移动端导航菜单 */}
        <nav className={`nav__mobile-links ${mobileMenuOpen ? 'nav__mobile-links--open' : ''}`}>
          {navLinks.map((link) => (
            <Link 
              key={link.path}
              className={[
                location.pathname === link.path ? 'active' : '',
                link.featured ? 'nav__mobile-link--featured' : ''
              ].filter(Boolean).join(' ')}
              to={link.path} 
              onClick={handleLinkClick}
            >
              <span>{link.label}</span>
              {link.featured && <span className="nav__mobile-badge">推荐</span>}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
